import React, { useState } from "react";
import HealthCard from "./HealthCard";
import { useSelector } from "react-redux";
import { getReadingList, Reading, useDynamicSelector } from "@src/redux/index";
import { Modal, Skeleton } from "antd";
import { VscTable } from "react-icons/vsc";
import { ISH_LEADS } from "@src/helpers/imagesConstants";
import { useTranslation } from "react-i18next";
import {
  getSkinValue,
  getVitalColorCode,
  sugarValueCalculate,
} from "@src/helpers/constants";

const HealthCardDetails: React.FC = () => {
  // const { result: data } = useSelector(get_reading);
  const { reading: data }: { reading: Reading } =
    useDynamicSelector("get_reading_details") || {};
  const { t } = useTranslation();
  const { loading: readingListLoading } = useSelector(getReadingList);
  const [ishScoreModal, setIshScoreModal] = useState<boolean>(false);
  const handleManageIsh = () => {
    setIshScoreModal(true);
  };
  const handleClose = () => {
    setIshScoreModal(false);
  };

  
  return (
    <>
      <div className="health-card-details">
        {readingListLoading ? (
          Array.from({ length: 8 }).map((_, index) => {
            return (
              <Skeleton.Button
                key={index}
                className="health-card-skelton-loading"
                active
              />
            );
          })
        ) : (
          <>
            <HealthCard
              title="Pulse Rate"
              value={data?.vincenseReading?.pulseValue || ""}
              unit="bpm"
              color={getVitalColorCode(
                data?.vincenseReading?.pulseColor || ""
              )}
              cardColor="#efefef"
            />
            <HealthCard
              title="SpO2"
              value={data?.vincenseReading?.o2Value || ""}
              unit="%"
              color={getVitalColorCode(
                data?.vincenseReading?.o2Color || ""
              )}
              cardColor="#efefef"
            />
            <HealthCard
              title="Skin Temp"
              value={getSkinValue(
                data?.vincenseReading?.skinValue,
                false,
                "-"
              )}
              color={getVitalColorCode("#B0BEC5")}
              unit="°C / °F"
              cardColor="#efefef"
            />
            <HealthCard
              title="RR"
              value={data?.vincenseReading?.rrValue || "-"}
              color={getVitalColorCode(
                data?.vincenseReading?.rrColor || "-"
              )}
              unit="bpm"
              cardColor="#efefef"
            />
            <HealthCard
              title="BP"
              value={data?.bpReading?.systolicValue || "--"}
              unit="mmHg"
              color={getVitalColorCode(
                data?.bpReading?.systolicColor || "#E57373",
                true
              )}
              secondaryColor={getVitalColorCode(
                data?.bpReading?.diastolicColor || "",
                true
              )}
              secondaryValue={data?.bpReading?.diastolicValue || "--"}
              cardColor="#efefef"
            />
            <HealthCard
              title="Sugar"
              value={sugarValueCalculate(
                Number(data?.glucometerReading?.randomValue || 0) ||
                  Number(data?.glucometerReading?.ppValue || 0) ||
                  Number(data?.glucometerReading?.fastingValue || 0)
              )}
              unit="mg/dl"
              color={getVitalColorCode(
                data?.glucometerReading?.randomColor ||
                  data?.glucometerReading?.fastingColor ||
                  data?.glucometerReading?.ppColor ||
                  "#B0BEC5",
                true
              )}
              cardColor="#efefef"
            />
            <HealthCard
              title="BMI"
              value={data?.weighingReading?.bmiValue || "--"}
              unit="Kg/m²"
              color={getVitalColorCode(
                data?.weighingReading?.bmiColor || "#B0BEC5"
              )}
              cardColor="#efefef"
            />
            <HealthCard
              title="ISH Score"
              value={data?.ishReading?.score || "-"}
              color={getVitalColorCode(data?.ishReading?.color || "")}
              unit="%"
              cardColor="#049eff"
              icon={<VscTable size={25} />}
              onClick={handleManageIsh}
            />
          </>
        )}
      </div>
      <Modal
        width={700}
        open={ishScoreModal}
        onCancel={handleClose}
        title={t("ish_table")}
        footer={null}
      >
        <img src={ISH_LEADS} className="ish-lead-image" />
      </Modal>
    </>
  );
};

export default HealthCardDetails;
